// libraries
import React, { useState, useEffect, useRef } from 'react'
import clsx from 'clsx'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

// components
import Button from '/react4xp/components/Button'
import Breadcrumbs from '/react4xp/components/Breadcrumbs'
import Guidelines from '/react4xp/components/Guidelines'

// utils
import { getFocusableElementsOutside } from '/lib/reactutils/utils'

// svg
import { GeneralPerson } from '/react4xp/components/Svg/Icons/General'

// props
interface HeaderProps {
    bgColor?: 'mini' | string
    logoColor?: 'white' | 'black'
    transparentMenu?: boolean
    whiteBreadcrumb?: boolean
    isPrototype?: boolean
    skipToMain?: string
    logoSvg?: string
    logoHref?: string
    logoAriaLabel?: string
    topMenu?: Array<{
        name: string,
        href: string,
        external?: boolean
    }>
    //loginText?: string
    //loginHref?: string
    searchHref?: string
    searchText?: string
    menuOpen?: string
    menuClose?: string
    breadcrumbs?: Array<{
        name: string,
        href?: string
    }>
    fsMenuFirstCol?: Array<{
        name: string,
        link: string,
        external?: boolean
    }>
    fsMenuSecondCol?: Array<{
        name: string,
        link: string,
        external?: boolean
    }>
    fsMenuThirdCol?: Array<{
        name: string,
        link: string,
        external?: boolean
    }>
    className?: string
    miniImage?: string
}

export default function Header({
    bgColor,
    logoColor,
    transparentMenu,
    whiteBreadcrumb,
    isPrototype,
    skipToMain = 'Gå til hovedinnhold',
    logoSvg = "<svg width='158' height='93' viewBox='0 0 158 93' xmlns='http://www.w3.org/2000/svg'><path d='M59.8075 41.4571C62.9023 37.4157 65.8983 33.2719 69.333 29.5062C73.574 24.8542 79.4197 19.4144 86.3167 20.8798C90.3838 21.7424 92.368 27.4146 93.4746 30.9045C94.0952 32.8583 94.6485 34.9263 95.1861 36.9076C97.1939 44.3129 98.8026 51.8207 100.099 59.3836C102.328 56.0315 104.186 52.2815 105.636 48.5198C107.664 43.2691 109.913 35.7495 106.901 30.5421C105.652 28.3875 102.81 26.3668 102.399 23.9443C101.822 20.5489 104.723 18.1894 107.992 18.8551C113.249 19.9305 114.371 27.84 113.79 32.2083C113.98 32.2595 113.976 32.1296 114.063 32.0468C114.715 31.4127 115.363 30.4437 116.012 29.7504C119.822 25.6696 127.656 19.1033 133.659 22.0063C138.248 24.2279 135.746 30.3925 134.493 33.9454C134.758 34.0045 134.659 33.8667 134.734 33.7564C135.181 33.0867 135.561 32.3305 136.003 31.6451C139.62 26.0438 145.722 19.1348 153.121 19.6823C161.153 20.2771 158.378 31.972 151.28 31.5387C148.094 31.3457 147.94 28.419 144.07 29.6598C138.13 31.5663 133.652 41.8589 131.687 47.2947C129.201 54.1762 127.193 61.7312 125.466 68.8529C125.328 69.4162 124.711 72.6265 124.49 72.7959L121.292 72.985C119.304 72.7841 116.826 73.2371 114.897 72.985C114.636 72.9495 114.439 72.8195 114.375 72.5517L125.466 33.4846C126.011 31.5466 126.478 27.6706 123.217 28.742C120.608 29.5968 116.514 34.3118 114.759 36.5058C114.174 37.2385 112.85 38.8101 112.557 39.6137C111.98 41.1853 111.632 43.1391 111.083 44.7935C106.996 57.1147 99.1069 69.3138 90.0913 78.6217C83.8267 85.0895 72.1115 94.4132 62.4952 92.81C59.4597 92.3019 56.0685 89.836 58.0882 86.4485C60.5743 82.2771 67.7006 84.6917 71.661 84.3569C80.1785 83.6321 87.0479 76.278 92.364 70.2867L92.4035 69.7707C90.5656 60.2974 88.206 50.9186 85.4986 41.6659C84.6764 38.8535 82.9018 31.6766 80.9493 29.8134C77.4988 26.5165 72.0246 32.9843 69.9219 35.3989C69.0326 36.4231 67.6255 37.9711 66.9299 39.0701C66.8508 39.1961 66.7718 39.2907 66.8231 39.4522C67.7045 43.4975 68.6452 47.5311 69.6926 51.5371C70.74 55.543 72.8111 64.9651 76.562 67.1473C79.5501 68.8884 82.8899 66.1508 84.9729 64.1695C85.542 63.9804 85.7792 64.1852 86.0242 64.6618C86.3602 65.3118 86.7792 66.4305 86.4946 67.1316C85.9966 68.3684 82.4117 71.1021 81.1904 71.8702C75.5265 75.4271 68.3883 75.7738 64.7362 69.3886C61.0841 63.0035 60.1 53.6208 58.6336 46.7512C58.6139 46.6566 58.598 46.4636 58.4676 46.4872L51.8749 72.7368C51.7524 72.9298 51.5666 72.9653 51.3571 72.9928C49.6773 73.1898 47.3216 72.9653 45.547 72.9889C45.3177 72.9889 45.1083 73.0913 44.879 73.0913C44.381 73.0992 41.9384 73.1858 41.7487 72.8786L41.7566 72.3862C46.3968 55.1806 51.7998 37.9396 55.44 20.4859C56.4914 15.4518 58.6771 7.36895 53.8156 3.75688C53.4322 3.46933 52.5745 3.07543 52.3215 2.83121C52.112 2.63032 52.2543 2.51215 52.4361 2.36247C53.7839 1.25561 57.1593 0.148749 58.8984 0.0305792C71.5819 -0.824186 66.2737 16.4681 64.5544 23.3968C63.0564 29.4392 61.3173 35.4305 59.8233 41.4729L59.8075 41.4571Z M33.0849 2.55154C38.4365 2.42943 44.4522 4.07988 47.4047 8.85396C49.6536 12.4936 49.871 17.9806 46.8434 21.2697C44.0806 24.2752 37.9701 23.8183 38.1361 18.9536C38.1914 17.2795 39.0926 15.8221 39.3653 14.2031C40.97 4.58801 26.6186 4.99373 23.3183 12.6709C20.3777 19.505 24.9981 25.3033 29.4288 29.9395C36.152 36.9824 41.4246 41.7171 41.8198 52.2933C42.389 67.6043 29.9861 77.2982 15.0972 74.6748C6.08553 73.0913 -1.45578 65.6229 0.239828 55.9881C1.01451 51.5725 5.84838 46.0146 10.6309 48.957C14.4885 51.3322 10.4925 56.2796 10.0103 59.3639C7.86414 73.1031 29.081 74.6236 31.911 62.003C35.1204 47.6926 18.8322 42.2095 13.8324 31.2118C7.30289 16.8383 18.022 2.89424 33.0849 2.55154Z' fill='currentColor'/></svg>",
    logoHref = '/',
    logoAriaLabel = 'Skyr',
    topMenu = [
        {
            href: '#',
            name: 'Produkter',
            //external: true
        },
        {
            href: '#',
            name: 'Oppskrifter'
        }
    ],
    //loginText,
    //loginHref,
    searchHref = '#',
    searchText = 'Søk',
    menuOpen = 'Meny',
    menuClose = 'Lukk',
    fsMenuFirstCol = [
        {
            name: 'Menu item 1',
            link: '#'
        },
        {
            name: 'Menu item 2',
            link: '#'
        },
        {
            name: 'Menu item 3',
            link: '#'
        },
        {
            name: 'Menu item 4',
            link: '#'
        },
        {
            name: 'Menu item 5',
            link: '#'
        }
    ],
    fsMenuSecondCol = [
        {
            name: 'Menu item 6',
            link: '#'
        },
        {
            name: 'Menu item 7',
            link: '#'
        },
        {
            name: 'Menu item 8',
            link: '#'
        },
        {
            name: 'Menu item 9',
            link: '#'
        }
    ],
    fsMenuThirdCol = [
        {
            name: 'Menu item 10',
            link: '#'
        },
        {
            name: 'Menu item 11',
            link: '#'
        },
        {
            name: 'Menu item 12',
            link: '#'
        }
    ],
    breadcrumbs,
    miniImage = '/images/mini.svg'
}: HeaderProps) {

    // custom bg color
    const customBgColor = bgColor && !['mini'].includes(bgColor) ? { backgroundColor: bgColor } : {}

    // animation ref
    const menuAnimationRef = useRef(null)

    // open / close fs menu
    const [isShown, setIsShown] = useState(false)

	const openCloseMenu = () => {
        setIsShown(!isShown)
	}

    // menu animation
    useGSAP(() => {
        const menuAnimation = gsap.timeline({
            paused: true
        })

        menuAnimation.to('#fs-menu', {
            opacity: 1,
            visibility: 'visible',
            ease: 'none',
            duration: 0
        })

        menuAnimation.to('#fs-menu', {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'power2.inOut',
            duration: 1
        })

        menuAnimation.to('.top-menu-item', {
            autoAlpha: 0,
            x: 50,
            ease: 'power2.inOut',
            duration: .6,
            stagger: .1
        }, '-=1')

        /*
        menuAnimation.to('.menu-login-button', {
            pointerEvents: 'all',
            visibility: 'visible',
            opacity: 1,
            x: 0,
            ease: 'power2.inOut',
            duration: .6
        }, '-=.7')
        */

        menuAnimation.to('#top-menu-logo span', {
            color: '#001f29',
            ease: 'power2.inOut',
            duration: .6
        }, '-=1')
    
        menuAnimation.fromTo('#fs-menu ul li', {
            y: -50,
            autoAlpha: 0
        }, {
            y: 0,
            autoAlpha: 1,
            stagger: .05
        }, '-=.7')
        
        // store the animation timeline in the ref
        menuAnimationRef.current = menuAnimation
    })

    useEffect(() => {
		setIsShown(isShown)

        const focusable_els = document.getElementById('trap-focus')
        const focusableElementsOutside = getFocusableElementsOutside(focusable_els)
    
        // disable focus on all elements outside the fs-menu when it's open
        const disableFocusOutside = () => {
            focusableElementsOutside.forEach((el) => {
                el.setAttribute('tabindex', '-1')
            })
        }
    
        // enable focus on all elements outside the fs-menu when it's closed
        const enableFocusOutside = () => {
            focusableElementsOutside.forEach((el) => {
                el.removeAttribute('tabindex')
            })
        }

        if (menuAnimationRef.current) {
            if (isShown) {
                menuAnimationRef.current.play()
                document.body.style.overflowY = 'scroll'
                document.body.style.position = 'fixed'
                disableFocusOutside()
            } else {
                menuAnimationRef.current.reverse()
                document.body.style.overflowY = 'auto'
                document.body.style.position = 'relative'
                enableFocusOutside()
            }
        }
	}, [isShown])

    useEffect(() => {
        window.onpageshow = () => {
            menuAnimationRef.current.progress(0).pause()
            setIsShown(false)   
        }
    }, [])

    return (
        <>

            {isPrototype && <Guidelines />}

            <Button
                href='#main'
                className='skip-to-main'
                isSolid
                noUnderline
                smallBorders
            >
                {skipToMain}
            </Button>

            <section
                id='top-menu'
                className={clsx(
                    bgColor === 'mini' && 'bg-mini'
                )}
                style={customBgColor}
            >

                <div id='trap-focus'>

                    {/* top menu */}
                    <div className='container relative z3'>

                        <div className='wrapper'>
                        
                            <a
                                href={logoHref}
                                id='top-menu-logo'
                                className='logo'
                                aria-label={logoAriaLabel}
                            >
                                <span
                                    dangerouslySetInnerHTML={{ __html: logoSvg }}
                                    suppressHydrationWarning
                                    className={clsx(bgColor != 'mini' && logoColor === 'white' ? 'white' : 'black')}
                                />
                            </a>

                            <div className='right'>

                                <ul>

                                    {topMenu.map((item, i) => (
                                        <li className='menu-item top-menu-item' key={i}>
                                            <Button
                                                href={item.href}
                                                target={!!item.external}
                                                noUnderline
                                                noBorders
                                                bigButton
                                                className={clsx(
                                                    transparentMenu && 'bg-transparent',
                                                    bgColor != 'mini' && whiteBreadcrumb && 'white'
                                                )}
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}

                                    {/*
                                    <li className='menu-item top-menu-item'>
                                        <Button href={loginHref}>
                                            <span className='limit'>
                                                {loginText}
                                            </span>
                                            <GeneralPerson variant='outline' />
                                        </Button>
                                    </li>
                                    */}

                                    <li className='menu-item top-menu-item'>
                                        <Button
                                            href={searchHref}
                                            noUnderline
                                            noBorders
                                            bigButton
                                            className={clsx(
                                                transparentMenu && 'bg-transparent',
                                                bgColor != 'mini' && whiteBreadcrumb && 'white'
                                            )}
                                        >
                                            {searchText}
                                            <span className='search-icon'>
                                                <span className='circle'></span>
                                                <span className='dash'></span>
                                            </span>

                                        </Button>
                                    </li>

                                    {/*
                                    <li className='login menu-login-button'>
                                        <Button
                                            href={loginHref}
                                            isSolid
                                        >
                                            <span className='limit'>
                                                {loginText}
                                            </span>
                                            <GeneralPerson variant='outline' />
                                        </Button>
                                    </li>
                                    */}

                                </ul>

                                <Button
                                    className={clsx(
                                        'open-fs-menu',
                                        isShown && 'active',
                                        transparentMenu && 'bg-transparent',
                                        bgColor != 'mini' && whiteBreadcrumb && 'white'
                                    )}
                                    onClick={openCloseMenu}
                                    noUnderline
                                    bigButton
                                >

                                    <span className='text'>
                                        {isShown ? menuClose : menuOpen}
                                    </span>

                                    <span className='menu-icon'>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </span>

                                </Button>

                            </div>

                        </div>
                    </div>

                    {/* fs menu */}
                    <div id='fs-menu'>
                        <div className='container'>
                            <div className='flex'>

                                <ul className='big-menu'>
                                    {fsMenuFirstCol.map((item, i) => (
                                        <li key={i}>
                                            <Button
                                                href={item.link}
                                                target={!!item.external}
                                                bigButton
                                                noUnderline
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>

                                <ul className='menu'>
                                    {fsMenuSecondCol.map((item, i) => (
                                        <li key={i}>
                                            <Button
                                                href={item.link}
                                                target={!!item.external}
                                                noUnderline
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>

                                <ul className='menu'>
                                    {fsMenuThirdCol.map((item, i) => (
                                        <li key={i}>
                                            <Button
                                                href={item.link}
                                                target={item.external}
                                                noUnderline
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}

                                    {/*
                                    <li className='login'>
                                        <Button
                                            href={loginHref}
                                            isSolid
                                        >
                                            <span className='limit'>
                                                {loginText}
                                            </span>
                                            <GeneralPerson variant='outline' />
                                        </Button>
                                    </li>
                                    */}

                                    <li className='search'>
                                        <Button href={searchHref}>

                                            {searchText}

                                            <span className='search-icon'>
                                                <span className='circle'></span>
                                                <span className='dash'></span>
                                            </span>

                                        </Button>
                                    </li>
                                    
                                </ul>

                            </div>
                        </div>
                    </div>

                </div>

                {bgColor === 'mini' && (
                    <div className='container relative z1'>
                        <div className='mini-sep'>

                            <div className='line'></div>

                            <img
                                src={miniImage}
                                alt='Mini'
                                width={110}
                                height={70}
                                loading='lazy'
                            />

                            <div className='line'></div>

                        </div>
                    </div>
                )}

                {breadcrumbs && (
                    <div className='container relative z1'>
                        <Breadcrumbs
                            className={clsx(
                                'breadcrumbs-header',
                                bgColor != 'mini' &&whiteBreadcrumb && 'white'
                            )}
                            breadcrumbs={breadcrumbs}
                        />
                    </div>
                )}

            </section>
            
        </>
    )
}